import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsKritaComponent } from './simple-icons-krita.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsKritaComponent ],
    exports:      [ SimpleIconsKritaComponent ],
    bootstrap:    []
})
export class SimpleIconsKritaModule {}
